import { endpoints } from './../../../environments/environment';
import { FormatPricePipe } from './../../shared/format-price.pipe';
import { Limit, LimiteGeralModel, LimitePrazoCompensacao, LimiteTipoPeriodo, LimitTipo } from './../limits/models/limits';
import { Auth } from './../../autentication/Auth';
import { map } from 'rxjs/operators/map';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Bank } from './../models/banks';
import { Observable } from 'rxjs/Observable';
import { Transfer } from '../models/transfer';
import * as moment from 'moment';
import { AccountNumberPipe } from '../../shared/account-number.pipe';
import { CpfCnpjPipe } from '../../shared/cpf-cnpj.pipe';
import { BenefactorDataModel } from '../models/benefactorData';
import { Util } from '../../utils/util';
import { TransferType } from './models/transferType.enum';
import { BaseResult } from '../../shared/models/base.result.model';
import { TedLimitModel } from './models/tedLimitModel';
import LimitUtil from '../../utils/limit-utils';


@Injectable()
export class TransfersOtherBanksService {

	banks: Array<Bank>;

	limits: Array<Limit>;

	public scheduleSpan: boolean;

	constructor(private http: HttpClient) { }

	getBanks(): Observable<Bank[]> {

		return this.http.get(endpoints.utils.banks).pipe(map((data: any) => {

			if (data.Sucesso) {

				this.banks = data.Retorno.map(item => {
					const bank = new Bank();
					bank.name = item.Nome.toLowerCase();
					bank.code = item.CodigoCompensacao;
					bank.label = bank.code + ' - ' + bank.name;
					bank.ispbCode = item.CodigoISPB;
					bank.popular = item.Popular;
					return bank;
				});

			}

			return this.banks;

		}));
	}

	sendTransfer(transfer: Transfer): Observable<any> {
		const accNumPipe = new AccountNumberPipe();

		const transferData: any = {
			CodBancoDestino: transfer.bankCode,
			DescBancoDestino: transfer.bankDesc,
			CodAgenciaOrigem: Auth.getInstance().getUser().agency,
			CodContaOrigem: Auth.getInstance().getUser().accountNumber,
			CodAgenciaDestino: transfer.destinationAgency,
			CodContaDestino: transfer.destinationAccount,
			TipoContaFavorecido: transfer.modality,
			Valor: transfer.value,
			Descricao: transfer.description,
			DataEmissao: transfer.date,
			Complemento: transfer.complement,
			FinalidadeSPB: 10,
			FinalidadeTes: 0,
			CPFCNPJFavorecido: transfer.favoredCpfCnpj,
			NomeFavorecido: transfer.favoredName,
			CPFSolicitante: Auth.getInstance().getUser().cpf
		};

		if (transfer.dateType !== 'today') {
			transferData.DataAgendamento = moment(transfer.date).format('YYYY-MM-DD');
		}

		return this.http.post(endpoints.transfers.otherBanks + transfer.transferType, transferData).pipe(map((data: any) => {
			return data;
		}));

	}

	confirmTransfer(transferId: number, transferType: string, favoredRemember: boolean): Observable<any> {

		const requestId = Util.generateUUID4();


		return this.http.post(endpoints.transfers.otherBanksV3 +
			transferType + '/' +
			transferId +
			endpoints.confirmation + '/' +
			requestId + '/' +
			favoredRemember, {})
			.pipe(map((data: any) => {
				return data;
			}));

	}

	getDataLimits(): Observable<any[]> {

		return this.http.get<BaseResult<LimiteGeralModel[]>>(`${endpoints.limits.getLimits}?tipoLimite=TODOS`).pipe(
			map((data: BaseResult<LimiteGeralModel[]>) => {

				const gridLimits: Array<any> = [];

				if (data.Sucesso) {

					const groupedLimits = LimitUtil.groupLimitsByPeriod(data.Retorno);

					gridLimits.push(groupedLimits);


					return groupedLimits;
				}

				return gridLimits;
			}));
	}

	getBenefactors() {
		return this.http.get(endpoints.benefactors.all + '?tipoFavorecido=outros', {}).pipe(map((data: any) => {
			const CP = new CpfCnpjPipe();

			let benefactors: Array<BenefactorDataModel> = [];

			if (data.Sucesso) {

				data.Retorno.map(item => {

					let benefactor: BenefactorDataModel = new BenefactorDataModel();

					benefactor = item.Contas.map(itemAccount => {

						let modalityAll: string;

						switch (itemAccount.TpConta) {
							case 'CC':
								modalityAll = 'Conta Corrente';
								break;
							case 'PP':
								modalityAll = 'Conta Poupança';
								break;
							case 'PG':
								modalityAll = 'Conta Pagamento';
								break;
						}

						benefactor = {
							name: item.Titular,
							cpfCnpj: CP.transform(item.CpfCnpj),
							id: itemAccount.Id,
							agency: itemAccount.Agencia,
							accountNumber: itemAccount.NroConta.replace(/^(\d{0,13})*(\d{1})/, '$1-$2'),
							bankCode: itemAccount.Banco,
							bankDesc: itemAccount.NomeBanco,
							modality: itemAccount.TpConta,
							modalityAll: modalityAll
						}

						benefactors.push(benefactor);
					});
				});

				return benefactors;
			}

		}));
	}

	getTEDLimit(): Observable<BaseResult<TedLimitModel[]>> {
		return this.http.get<BaseResult<TedLimitModel[]>>(`${endpoints.limits.getLimits}?tipoLimite=TED`);
	}
}


// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/transfers-other-banks/transfers-other-banks.service.ts